module.exports = __webpack_public_path__ + "img/chevron-up-red.03b69722.svg";